import { render, staticRenderFns } from "./KeyFinding.vue?vue&type=template&id=45477ec2&scoped=true"
import script from "./KeyFinding.vue?vue&type=script&lang=js"
export * from "./KeyFinding.vue?vue&type=script&lang=js"
import style0 from "./KeyFinding.vue?vue&type=style&index=0&id=45477ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45477ec2",
  null
  
)

export default component.exports